var exports = {
  "container": "x24da60e8--ded68d--container",
  "desktop": "x24da60e8--ded68d--desktop",
  "logo": "x24da60e8--ded68d--logo",
  "with-background": "x24da60e8--ded68d--with-background",
  "content": "x24da60e8--ded68d--content",
  "links": "x24da60e8--ded68d--links",
};

module.exports = exports;
